<template>
  <div class="profile">
      <div class="proFileBox">
        <div v-if="list" class="item acea-row row-between"
          v-for="(item, index) in list">
          <img class="pic" :src="item.img" alt="">
          <div class="txt">
            <!-- <p class="en">{{ item.entitle }}</p> -->
            <h4>{{ item.title }}</h4>
            <div class="cont">
              {{ item.describe }}
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
     list: [] 
    }
  },
  created () {
    this.$api.get("home/index/parenterlist", {}).then((res) => {
      this.list = res.data.ebersparenterlist
      console.log("home/index/parenterlist-------------------",res)
    });
  }
};
</script>

<style lang="scss" scoped>
 .profile {

    .proFileBox {
      width: 1400px;
      margin: 0 auto;
      .item {
        margin-top: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        .pic {
          width: calc(50% - 20px);
        }

        .txt {
          width: 50%;

          .en {
            margin-top: 70px;
            font-size: 50px;
            color: rgba($color: #1D2A55, $alpha: 0.35);
          }

          h4 {
            font-size: 48px;
            // color: #1D2A55;
            color: #000;
            padding: 0px 30px;
          }

          .cont {
            margin-top: 30px;
            padding: 20px 30px;
            // background: rgba($color: #1D2A55, $alpha: 0.05);
            font-size: 20px;
            line-height: 150%;
            // height: 450px;
            // color: #1D2A55;
            color: rgb(119,119,119);
            // padding-right: 25%;
            overflow-y: auto;
          }
        }

        &:nth-child(2n) {
          .en {
            // text-align: right;
          }

          h4 {
            // text-align: right;
          }

          .cont {
            // padding-right: 30px;
            // padding-left: 25%;
          }
        }
      }
    }
  }
  @media screen and(max-width:1400px) {
    .profile {
      .proFileBox {
        width: 100%;
        .item {
          .txt {
            .en {
              font-size: 40px;
            }

            h4 {
              font-size: 36px;
              margin-top: 30px;
            }

            .cont {
              font-size: 18px;
              // height: 350px;
            }
          }
        }
      }
    }
  }
  @media screen and(max-width:1200px) {
    .profile {
      .proFileBox {
        .item {
          .txt {
            .en {
              font-size: 36px;
              margin-top: 50px;
            }

            h4 {
              font-size: 32px;
            }

            .cont {
              font-size: 16px;
              // height: 300px;
              margin-top: 40px;
            }
          }
        }
      }
    }
  }

  @media screen and(max-width:768px) {

  .profile {
      padding: 15px 15px;
      padding-top: 1px;

      .proFileBox {
        .item {
          margin-top: 20px;

          .pic {
            // max-height: 240px;
            width: 100%;
          }

          .txt {
            width: 100%;
            height: auto;
            background: #F5F5F5;;
            .en {
              font-size: 14px;
              line-height: 20px;
              margin-top: 10px;
              padding: 0px 15px;
            }

            h4 {
              font-size: 16px;
              line-height: 20px;
              padding: 0px 15px;
              margin-top: 20px;
              color: #4D4D4D;
            }

            .cont {
              margin-top: 10px;
              max-height: 400px;
              // overflow-y: auto;
              background: none;
              padding: 10px 15px;
              font-size: 14px;
              color: #999999;
            }
          }
        }
      }
    }
  }
</style>